module.exports = __webpack_public_path__ + "static/media/kz.c295c491.svg";